import state from "../state/state";
import { getStatusSelectionId, normalizeStatusSelectionRefs, toStatusSelectionRef } from "../utils/statusSelectionUtils";

export function clearStatusItems(tree) {
	tree.set(["appState", "statusItems"], []);
}

export function setStatusItems(items) {
	state.set(["appState", "statusItems"], items);
}

export function addStatusItem(tree, item) {
	tree.select(["appState", "statusItems"]).push(item);
}

export function selectStatusItem(item) {
	if (state.get(["appCapabilities", "multiSelect"])) {
		const ref = toStatusSelectionRef(item);
		if (!ref) {
			return;
		}
		let selected = normalizeStatusSelectionRefs(state.get(["appState", "selectedStatusItems"]));

		const index = selected.findIndex((newItem) => ref.instanceId === getStatusSelectionId(newItem));

		// Check if already selected, if so splice, if not push
		// const index = selected.indexOf(itemId);
		if (index > -1) {
			selected.splice(index, 1);
		} else {
			selected.push(ref);
		}

		state.set(["appState", "selectedStatusItems"], Object.assign([], selected));
	}
}

export function ensureSelectedStatusItem(item) {
	if (state.get(["appCapabilities", "multiSelect"])) {
		const ref = toStatusSelectionRef(item);
		if (!ref) {
			return;
		}
		const selected = normalizeStatusSelectionRefs(state.get(["appState", "selectedStatusItems"]));
		const alreadySelected = selected.findIndex((newItem) => ref.instanceId === getStatusSelectionId(newItem)) > -1;
		if (!alreadySelected) {
			state.set(["appState", "selectedStatusItems"], selected.concat([ref]));
		} else {
			state.set(["appState", "selectedStatusItems"], selected);
		}
	}
}

export function removeSelectedStatusItem(instanceId) {
	if (state.get(["appCapabilities", "multiSelect"])) {
		const selected = normalizeStatusSelectionRefs(state.get(["appState", "selectedStatusItems"]));
		state.set(
			["appState", "selectedStatusItems"],
			selected.filter((item) => getStatusSelectionId(item) !== instanceId)
		);
	}
}

export function resetSelectedStatusItems(tree) {
	if (tree.get(["appCapabilities", "multiSelect"])) {
		tree.set(["appState", "selectedStatusItems"], Object.assign([]));
	}
}

export function selectAllStatusItems(tree) {
	if (tree.get(["appCapabilities", "multiSelect"])) {
		const statusItems = normalizeStatusSelectionRefs(tree.get(["appState", "statusItems"]));

		const selected = normalizeStatusSelectionRefs(tree.get(["appState", "selectedStatusItems"]));
		for (let i = 0; i < statusItems.length; i++) {
			const statusItem = statusItems[i];
			if (!selected.find(item => getStatusSelectionId(item) === statusItem.instanceId)) {
				selected.push(statusItem);
			}
		}


		tree.set(["appState", "selectedStatusItems"], Object.assign([], selected));
	}
}
